import request from '@/utils/request';
import { requestEndpoint } from '@/constants/urls';

const cohort = (code) => request({
  url: `${requestEndpoint(code)}/cohort`,
  method: 'GET',
});

const SystemCohortService = {
  cohort,
};

export default SystemCohortService;
